module.exports = __webpack_public_path__ + "static/media/e&oHead2.52611e18.jpg";